module.exports = __webpack_public_path__ + "img/sample-05.ca92ce34.jpg";